import { Contact } from '@/components/contact';
import { ReportForm } from '@/components/report-form';
import { View } from '@/components/ui/tw-wrappers';
import { SCREEN_MAX_WIDTH } from '@/constants/layout';
import { Country } from '@/types/country';
import { TransferPair } from '@/types/transfer-pair';
import React from 'react';
import { StyleSheet } from 'react-native';

interface FooterCtaSectionProps {
  countries: Country[];
  data?: TransferPair;
  loading?: boolean;
  modelType: 'compare' | 'benchmarking';
}

export function FooterCtaSection({
  countries,
  data,
  loading,
  modelType,
}: FooterCtaSectionProps) {
  return (
    <View style={styles.footerCTAOuterContainer}>
      <View className='flex-col md:flex-row' style={styles.footerCTAInnerContainer}>
        <View className='w-full md:w-1/2'>
          <ReportForm
            data={data}
            countries={countries}
            disabled={loading}
            modelType={modelType}
          />
        </View>
        <View className='w-full md:w-1/2 md:flex-1'>
          <Contact />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  footerCTAOuterContainer: {
    width: '100%',
    backgroundColor: '#F9FAFB',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerCTAInnerContainer: {
    gap: 16,
    paddingVertical: 40,
    maxWidth: SCREEN_MAX_WIDTH,
    paddingHorizontal: 16,
    width: '100%',
  },
});
